import React, {  useEffect, useState } from 'react';
import { Chip, ExtendedTheme } from 'neon-design-system';
import { createStyles, Grid, makeStyles } from '@material-ui/core';
import ChannelPreviewList from '../../ui/ChannelPreviewList';
import SectionHeader from '../../ui/SectionHeader';
import { useQuery } from '@apollo/react-hooks';
import { GET_CHANNELS } from '../../../gql/channels';
import { Channel, ChannelTypes } from '../../../shared/types';
import { randomizeChannels } from './ChannelsGrid/ChannelsGridUtils';
import SkeletonCardGrid from '../../ui/Skeletons/SkeletonCardGrid';

const useStyles = makeStyles<ExtendedTheme>(theme => createStyles({
	filter: {
		display: 'flex',
		gap: theme.spacing(1)
	}
}));

enum FilterType { All, Premium, Free }

const ChannelsPage = () => {
	const classes = useStyles();
	const { loading, data } = useQuery(GET_CHANNELS, { fetchPolicy: 'network-only' });
	const allChannels = randomizeChannels(data?.channels) as Channel[];
	const isPremiumChannelsFilter = window.location.href.indexOf('?premium') > -1;
	const isFreeChannelsFilter = window.location.href.indexOf('?free') > -1;
	const defaultFilterType = isPremiumChannelsFilter ? FilterType.Premium : isFreeChannelsFilter ? FilterType.Free : FilterType.All
	const [filterType, setFilterType] = useState<FilterType>(defaultFilterType);
	const [channels, setChannels] = useState<Channel[]>(allChannels);

	useEffect(() => {
		if (loading || !allChannels) return;

		const channelsToShow = allChannels.filter((channel) => {
			switch (filterType) {
			case FilterType.Premium:
				return channel.type === ChannelTypes.premium;
			case FilterType.Free:
				return channel.type === ChannelTypes.freeOpen || channel.type === ChannelTypes.freeClosed;
			default:
			case FilterType.All:
				return true;
			}
		});

		setChannels(channelsToShow);
	}, [allChannels, filterType, loading])

	const filterStyle = (selectedFilterType: FilterType) =>
		selectedFilterType === filterType ? 'primary' : 'default';

	return (
		<>
			<Grid container spacing={2} >
				<Grid id="channels-header" item xs={12}>
					<SectionHeader sectionHeaderOffsetDisabled={true} title="Find channels and subscribe" />
				</Grid>
				<Grid id="channels-chips" item xs={12}>
					<div className={classes.filter}>
						<Chip label="All channels" styleName={filterStyle(FilterType.All)} onClick={() => setFilterType(FilterType.All)} />
						<Chip label="Premium" styleName={filterStyle(FilterType.Premium)} onClick={() => setFilterType(FilterType.Premium)} />
						<Chip label="Free" styleName={filterStyle(FilterType.Free)} onClick={() => setFilterType(FilterType.Free)} />
					</div>
				</Grid>
				<Grid id="channels-list" item xs={12}>
					{!loading && channels?.length ?
						<ChannelPreviewList
							channels={channels}
							loading={loading}
						/> :
						<SkeletonCardGrid
							generatedItemsLength={9}
							containerProps={{
								spacing: 2
							}}
							itemProps={{
								xs: 12,
								sm: 6,
								md: 4
							}}
						/>
					}
				</Grid>
			</Grid>
		</>
	);
}

export default ChannelsPage;
